import { Quill } from 'react-quill-new';

const Parchment = Quill.import('parchment');

const MarginStyle = new Parchment.StyleAttributor('margin', 'margin', {
  scope: Parchment.Scope.BLOCK,
});

export default MarginStyle;
